export const style = {
  label: {
    fontSize: `11px`,
    fontWeight: 400,
    padding: `5px 10px 6px`,
    display: `inline-block`,
    color: `white`,
    width: `67px`,
    textAlign: `center`,
    '::first-letter': {
      textTransform: `uppercase`
    }
  },
  box: {
    display: `block`,
    height: `8px`,
    width: `8px`,
    borderRadius: `50%`
  },
  low: {
    background: `#d9534f`
  },
  high: {
    background: `#5cb85c`
  },
  mid: {
    background: `#ffc600`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Support/style/status.js